import React from "react";
import NumberFormat from "react-number-format";

export default function PoCostVendorSummary({
  totalCostCharge = 0,
  totalItemCost = 0,
  totalCost = 0,
}) {
  return (
    <div className="po-cost-summary">
      <h6 className="secondary-title" style={{ marginBottom: 20 }}>
        PO Summary
      </h6>
      <div className="row">
        <div className="col-12">
          <div className="item-section">
            <label>Total Items List Cost</label>
            <NumberFormat
              value={totalItemCost}
              displayType={"text"}
              prefix={"$"}
              decimalScale={2}
              fixedDecimalScale={true}
              thousandSeparator={true}
              allowEmptyFormatting
            />
          </div>

          <div className="item-section">
            <label>Total 3rd Party Charges</label>
            <NumberFormat
              value={totalCostCharge}
              displayType={"text"}
              prefix={"$"}
              decimalScale={2}
              fixedDecimalScale={true}
              thousandSeparator={true}
              allowEmptyFormatting
            />
          </div>
        </div>

        <div className="col-12">
          <div
            className="item-section"
            style={{
              border: "1px solid #1c1c1c",
              padding: "8px 0",
              borderLeft: "none",
              borderRight: "none",
            }}
          >
            <label>Total Cost</label>
            <NumberFormat
              value={totalCost}
              displayType={"text"}
              prefix={"$"}
              decimalScale={2}
              fixedDecimalScale={true}
              thousandSeparator={true}
              allowEmptyFormatting
            />
          </div>
        </div>
      </div>
    </div>
  );
}
